import {
    Backdrop,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../AppContext";
import SmallTablePlaceholder from "../SmallTablePlaceholder";
import OrderItemTableEntry from "./OrderItemTableEntry";
import { useStyles } from "./styles";

const OrdersListWidget = ({
    entryItems,
    handleNext,
    backCallback,
    table,
    isInvoiceLoading,
    distTable,
}) => {
    const classes = useStyles();

    const tables = [
        {
            name: table?.tableDescription,
            floor: "1",
            actions: [],
        },
    ];

    const [selectedOrder, setSelectedOrder] = useState(null);

    const [orderItemMap, setOrderItemMap] = useState(new Map());
    const [itemsPayloads, setItemsPayloads] = useState(new Map());

    const { getMenuItem, menuAddons } = useContext(AppContext);

    const [payingAll, setPayingAll] = useState(true);

    const addToMap = (key, value) => {
        const updatedMap = new Map(orderItemMap);
        updatedMap.set(key, value);
        setOrderItemMap(updatedMap);
    };

    useEffect(() => {
        if (entryItems && entryItems.length > 0) {
            entryItems.forEach((item) => {
                let anotherMap = new Map();
                anotherMap.set("qty", item.qty);
                anotherMap.set("toQty", 0);
                anotherMap.set("rate", item.rate);
                anotherMap.set("toRate", 0);
                anotherMap.set("addons", item.addons);
                anotherMap.set("notes", item.notes);
                addToMap(item.identifier, anotherMap);
            });
        } else {
            // we have to cancel the operation because we have no orders.
        }
    }, [entryItems]);

    const nextClicked = () => {
        const totalModifiedPayload = {
            items: {},
        };

        itemsPayloads.forEach((itemPayload, identifier) => {
            totalModifiedPayload.items[identifier] = itemPayload;
        });

        totalModifiedPayload.client = "obj_3a5d-bf-457-825-0c237";

        if (handleNext) handleNext(totalModifiedPayload);
    };

    const handleBackCallback = () => {
        if (backCallback) {
            backCallback();
        }
    };

    const handlePayloadGenerated = (identifier, itemPayload) => {
        let qty = itemPayload.qty;
        if (qty === 0) {
            itemsPayloads.delete(identifier);
        } else {
            itemsPayloads.set(identifier, itemPayload);
        }

        // Doing this because I want to exit the scope of the caller.
        setTimeout(() => {
            updatePayingAll();
        }, 10);
    };

    const updatePayingAll = () => {
        setPayingAll(itemsPayloads.size === 0);
    };

    return (
        <div className={classes.AddPaymentWidget}>
            {!distTable && (
                <div className={classes.SmallTablePlaceholderWrapper}>
                    <SmallTablePlaceholder
                        tables={tables}
                        backCallback={handleBackCallback}
                    />
                </div>
            )}
            {isInvoiceLoading ? (
                <Backdrop open={true} className={classes.OrderItemsBackdrop}>
                    {" "}
                    <CircularProgress />{" "}
                </Backdrop>
            ) : (
                <>
                    <TableContainer
                        component={Paper}
                        className={classes.tableContainer_11}
                    >
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Current</TableCell>
                                    <TableCell>Picture</TableCell>
                                    <TableCell>Item</TableCell>
                                    <TableCell>Qty</TableCell>
                                    <TableCell>Total</TableCell>
                                    <TableCell>Qty</TableCell>
                                    <TableCell>Total</TableCell>
                                    <TableCell>Move</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {entryItems && entryItems.length > 0 ? (
                                    entryItems.map((item) => {
                                        return (
                                            <OrderItemTableEntry
                                                key={item.name}
                                                item={item}
                                                selectedOrder={selectedOrder}
                                                handlePayloadGenerated={
                                                    handlePayloadGenerated
                                                }
                                                image={
                                                    getMenuItem(item.item_code)
                                                        ?.cover
                                                }
                                                payingAll={payingAll}
                                            ></OrderItemTableEntry>
                                        );
                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center">
                                            No items available.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div className={classes.Actions}>
                        <button className="Btn--Primary" onClick={nextClicked}>
                            {distTable ? "Move" : "Pay"}
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default OrdersListWidget;
